/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useState } from 'react';
import { postDataApi } from '../../../../../api/methods';
import { constants } from '../../../../../helpers';
import { onSetCanResendOtp, onToggleModal } from '../../../../../redux/features/commonSlice';
import { verifyOtp } from '../../../../../redux/services/auth';
import { useAppDispatch, useAppSelector } from '../../../../custom-hooks';
import Component from './Component';

function ForgotPasswordVerifyEmail(props) {
    const dispatch = useAppDispatch();
    const commonReducer = useAppSelector(state => state.common);

    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');


    const handleOtpChange = useCallback((value) => {
        // Only allow numbers
        const regex = /^[0-9\b]+$/;
        if (regex.test(value) || value === '') {
            setOtp(value);
            if (otpError !== '') {
                setOtpError('');
            }
        }
    }, [otpError]);

    const handleVerifyOtp = useCallback(() => {
        if (!(commonReducer.modal?.forgotPassword?.email)) return false;

        const data = {
            type: constants.API_TYPE.FORGOT_PASSWORD,
            email: commonReducer.modal.forgotPassword.email,
            otp,
            callback: (response) => {
                if (response.statusCode === 200) {
                    setOtpError("");
                    dispatch(onToggleModal({ modalType: constants.MODAL.SET_NEW_PASSWORD }));
                } else if (response.data.type === "INVALID_OTP") {
                    setOtpError(response.data.message);
                } else if (response.data.type === "OTP_EXPIRED") {
                    setOtpError(response.data.message);
                    dispatch(onSetCanResendOtp({ canResendOtp: true }));
                } else {
                    setOtpError(response.message);
                }
            }
        };
        dispatch(verifyOtp(data));
    }, [commonReducer, otp, dispatch]);

    const handleResendOtp = useCallback(() => {
        if (!(commonReducer.modal?.forgotPassword?.email) || !(commonReducer.modal?.canResendOtp)) return false;

        dispatch(onSetCanResendOtp({ canResendOtp: false }));

        const data = {
            email: commonReducer.modal.forgotPassword.email,
            notify: true,
            callback: () => {
                setTimeout(() => {
                    dispatch(onSetCanResendOtp({ canResendOtp: true }));
                },
                    constants.RESEND_OTP_TIME_LIMIT.FORGOT_PASSWORD
                );
            }
        };
        postDataApi({ path: constants.API_PATHS.USER_RESEND_OTP, data });
    }, [commonReducer.modal, dispatch]);

    return <Component
        {...props}
        otp={otp}
        canResendOtp={!!(commonReducer.modal?.canResendOtp)}
        email={commonReducer.modal?.forgotPassword?.email || ''}
        otpError={otpError}
        actionType={commonReducer.actionType}
        onSetOtp={handleOtpChange}
        onVerifyOtp={handleVerifyOtp}
        onResendOtp={handleResendOtp}
    // onClose={handleOnClose}
    />;
}

export default ForgotPasswordVerifyEmail;
